import { useState, useEffect, useContext, useRef } from "react";
import { Swd_func } from "../../../api/app/swd_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { Card, MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Dropdown, Popover, PopoverTrigger, PopoverSurface, ButtonProps, Tooltip, Spinner } from "@fluentui/react-components";
import { AddSquare20Regular, SaveCopy20Regular, Info20Filled, Filter20Filled, FilterDismiss20Filled, SlideEraser20Regular, Warning20Filled, ArrowMaximize20Regular, Desktop20Filled, Delete24Regular, AddSquare20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, DismissSquare24Filled, AppsAddIn20Regular, BookTemplate20Regular, BoxCheckmark20Regular, CheckboxCheckedSync20Regular, PulseSquare20Regular, ShieldLock20Regular, SquareHintApps20Regular, UninstallApp20Regular, Dismiss16Regular, Delete20Regular, AppsListDetail20Filled, AppsList20Regular, Info16Filled } from "@fluentui/react-icons";
import { SearchBox } from "@fluentui/react-search-preview";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { Form } from "@rjsf/fluent-ui";
import React from "react";
import { CustomWidgets } from '../../../components/form-components';
import validator from '@rjsf/validator-ajv8';
import { GlobalContext } from "../../../hooks/globalContext";
import DialogBox from "../../../components/dialog/dialog.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { fullscreenIcon, primaryIcon, secondaryIcon, exitIcon, messageTheme, lightTheme, overflowDivider, buttonContent, dividerWidthStyle, heightResponsive, DynamicBoxingCSS, parentHome, wraperStyle, SubSectionResponsive, timezoneInfo, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { useLocation } from "react-router-dom";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../../utility/utils";
import { DatepickerComponent } from "../../../components/picker/datepicker.component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { AutomateAppPages } from "../../../components/side_menu/InlineSidenav";

declare module 'json-schema' {
  export interface JSONSchema7 {
    enumNames?: Array<string>;
  }
}

export const Appuninstallprofile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const handle = useFullScreenHandle();
  var tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState([]);
  const [tableData, setTableData] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [spinnerLoad, setSpinnerLoad] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [rowID, setRowID]: any = useState(null);
  const [rowconfID, setRowconfID]: any = useState(null);
  const [installationOverLayData, setInstallationOverLayData]: any = useState([]);

  const [searchVal, setSearchVal] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);

  const [isdeletedisabled, setDeleteDisabled] = useState(false);
  const [savePackageDetails, setSavePackageDetails] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();

  const [jsonSchemaPkg, setJsonDataPkg]: any = useState({});
  const [uiSchemaPkg, setUiDataPkg]: any = useState({});
  const [jsonSchemaApp, setJsonDataApp]: any = useState({});
  const [uiSchemaApp, setUiDataApp]: any = useState({});
  const [jsonSchemaAdv, setJsonDataAdv]: any = useState({});
  const [uiSchemaAdv, setUiDataAdv]: any = useState({});

  const [type, setType] = useState('Uninstallation');
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);

  const [formDataPkg, setFormDataPkg]: any = React.useState({});
  const [formDataApp, setFormDataApp]: any = React.useState({});
  const [formDataAdv, setFormDataAdv]: any = React.useState({});

  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  // const [permissions, setPermissions] = useState(['']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const formRef = useRef(null);
  const [uniqueOS, setUniqueOS] = useState([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
  const [isOsName, setOsName] = useState([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  useEffect(() => {
    setOsName(uniqueOS?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setStatusOptions(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueOS, uniqueStatus]);

  // call the save package here
  const saveBtnFunc = () => {
    setSavePackageDetails(true)
    setIsToast(true)
    setOverlayOpen(false)
  }

  const handleFilterArray = (): void => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    // Check if the column is already filtered
    const columnExists = filterArray.some(filter => filter.startsWith(`${value1} :`));
    if (!columnExists) {
      const result = `${value1} : ${value2}`;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
      setLoading(true);
      setDropDownValue1('');
      setDropDownValue2('');
    }
  };

  const handleCloseFilter = (index: any): any => {
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    if (updatedArray.length === 0) {
      setIsFilter(false);
      setResetDisabled(true);
    }
    setLoading(true);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_ -]*$/;
    const regexN = /^[0-9\.]*$/;
    if (name === 'filter' && dropDownValue1 === ("Name")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Version")) {
      if (regexN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Description")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
  }

  const handleEditData = (data: any) => {
    const pkgDetails = JSON.parse(data[0].formDataPkg)
    const appDetail = JSON.parse(data[0].formDataApp)
    const advDetail = JSON.parse(data[0].formDataAdv)
    setFormDataPkg(pkgDetails)
    setFormDataApp(appDetail);
    setFormDataAdv(advDetail);
  }
  console.log("DATAUP", formDataApp)
  const [deleteprofile, setDeleteprofile]: any = useState(false);
  const [deleteId, SetDeleteId]: any = useState([]);

  // logic for clone form starts here
  interface FormItem {
    id: number;
    data: {};
  }

  //data table column name code starts here
  // var columns = [
  //   { key: "names", label: <Body1Strong> &nbsp; Name </Body1Strong> },
  //   { key: "description", label: <Body1Strong>Description </Body1Strong>},
  //   { key: "version", label: <Body1Strong>Version</Body1Strong> },
  //   { key: "os", label: <Body1Strong>Operating System</Body1Strong> },
  //   { key: "created_on", label: <Body1Strong>Created On (UTC)</Body1Strong> },
  //   { key: "created_on_timezoned", label: <Body1Strong>Created On ({formattedTimeZone})</Body1Strong> },
  //   { key: "modified_on", label: <Body1Strong>Modified On</Body1Strong> },
  //   { key: "modified_on_timezoned", label: <Body1Strong>Modified On ({formattedTimeZone})</Body1Strong> },
  //   // { key: "status", label: <Body1Strong>Status</Body1Strong> },
  // ];

  //data table for filter starts here
  // var columns1 = [
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "description", label: <Caption1>Description </Caption1>},
  //   { key: "version", label: <Caption1>Version</Caption1> },
  //   { key: "os", label: <Caption1>Operating System</Caption1> },
  //   { key: "created_on", label: <Caption1>Created On </Caption1> },
  //   { key: "modified_on", label: <Caption1>Modified On</Caption1> },
  //   { key: "status", label: <Caption1>Status</Caption1> },
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.apps?.App_UnInstallation.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "created_on_timezoned" || val.key === "modified_on_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });
    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);
    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.apps?.App_UnInstallation.filter((val) => val.priority >= 0));
    contextValue.setManageViewPageDetails({ module: "apps", page: "App_UnInstallation" });
  }, [contextValue.tableColumnsData]);

  //data table column name code ends here
  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          {permissions.includes("all") || permissions.includes("appUnInstall_Fullaccess") ?
            <StackItem onClick={() => {
              setFormDataPkg({});
              setOverlayOpen(true); setOverlayName('addInstallation'); setStatus(true);
              setSpinnerLoad(false);
            }}>
              <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem>{loading ? <AddSquare20Regular {...secondaryIcon} /> : <AddSquare20Regular {...primaryIcon} />}</StackItem>
                      <StackItem> <Caption1> Create App Uninstall Profile </Caption1> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </StackItem>
            :
            <StackItem>
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Create App Uninstall Profile </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
            </StackItem>
          }

          <StackItem>
            <Divider vertical />
          </StackItem>
          <StackItem>
            <DialogBox
              headerButton={
                <>
                  <Button shape="circular" appearance="transparent" size="small"
                    disabled={isdeletedisabled ? false : true} >
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem>
                        {/* <SlideEraser20Regular {...primaryIcon} />  */}.
                        {isdeletedisabled
                          ? (<Delete20Regular {...primaryIcon} />)
                          : (<Delete20Regular {...secondaryIcon} />)
                        }
                      </StackItem>
                      <StackItem> <Caption1> Delete </Caption1> </StackItem>
                    </Stack>
                  </Button>
                </>
              }

              content="Kindly verify your intent to delete the app uninstall profile."

              footer=
              {
                <>
                  <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <StackItem>
                      <Button shape="circular" appearance="primary" onClick={() => { setDeleteprofile(true) }} size="small">Confirm</Button>
                    </StackItem>
                    <StackItem>
                      <Button shape="circular" size="small">Cancel</Button>
                    </StackItem>
                  </Stack>
                </>
              }
            />
          </StackItem>
          <StackItem>
            <Divider vertical />
          </StackItem>

          {/* <Stack tokens={{childrenGap:6}}> */}
          <StackItem><Text></Text></StackItem>
          <StackItem>
            <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
                <StackItem> <Caption1> Refresh </Caption1> </StackItem>
              </Stack>
            </Button>

            {permissions.includes("all") || permissions.includes("appUnInstall_Fullaccess") || permissions.includes("appUnInstall_ReadandExport") ?
              <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_uninstallprofile_list.csv`} />
              <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => setExportBtnClicked(true)}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button></>
              :
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Export </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
            }

            {/* <StackItem> */}
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />}  </StackItem>
                <StackItem> <Caption1> Manage View </Caption1> </StackItem>
              </Stack>
            </Button>
            {/* </StackItem> */}
          </StackItem>
          {/* </Stack> */}
        </Stack>
      </>
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  
    useEffect(() => {
      const uniqueIds = new Set(); 
      const tempExportData: any[] = [];
  
      exportDetails?.forEach((val: any) => {
          if (!uniqueIds.has(val.app_packageId)) {
              uniqueIds.add(val.app_packageId);
              tempExportData.push({
                  "ID": val.id,
                  "App PackageID": val.app_packageId ? val.app_packageId : '',
                  "Names": val.packageName ? val.packageName : '',
                  "Description": val.packageDesc ? val.packageDesc : '',
                  "Version": val.version ? val.version : '',
                  "Operating System": val.platform ? val.platform : '',
                  // "Created On":  val.creationTime ? convertToExcelFormat(val.creationTime): '',
                  // "Modified On": val.lastModified ? convertToExcelFormat(val.lastModified) : '',
                  "Status": val.status ? val.status : '',
                  "Path": val.path ? val.path : '',
                  "Application Name": val.applicationName ? val.applicationName : '',
              });
          }
      });
  
      setExportData(tempExportData);
  }, [exportDetails]);


  useEffect(() => {
    console.log("final_data=", final_data);

    if (Array.isArray(final_data)) {
      const newUniqueOs: any = [];
      const newUniqueStatus: string[] = [];


      final_data.forEach((val: any) => {
        if (newUniqueOs.indexOf(val.platform) === -1) {
          newUniqueOs.push(val.platform); // Add unique OS name
        }
        if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        }
      });

      setUniqueOS(newUniqueOs);
      setUniqueStatus(newUniqueStatus);

      console.log("Unique operating System:", newUniqueOs);
    } else {
      setUniqueOS([]);
      setUniqueStatus([]);
    }
  }, [final_data]);

  useEffect(() => {
    // data table values append code starts here
    console.log("final_data=", final_data);

    const uniqueIds: any = new Set(); // Set to store unique app_packageIds
    const updatedTempTableData = final_data !== undefined && final_data !== null && final_data?.length > 0
      ? final_data?.reduce((accumulator: any, val: any, i: any) => {
        if (!uniqueIds.has(val.app_packageId)) {
          uniqueIds.add(val.app_packageId); // Add app_packageId to the set          
          {
            permissions.includes("all") || permissions.includes("appUnInstall_Fullaccess") ?
              accumulator.push({
                id: val.app_packageId,
                // checkbox: "show",
                names: { label: <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={(e: any) => { setRowID(val.id); setRowconfID(val.app_packageId); setOverlayOpen(true); setOverlayName('editInstallation'); setSpinnerLoad(true)}}> {val.packageName !== null ? val.packageName : 'N/A'} </Button>, icon: "", id: `${i}` },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1> },
                os: { label: <Caption1> {val.platform} </Caption1> },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                // status: { label: <Caption1> {val.status} </Caption1>},
              })
              :
              accumulator?.push({
                id: val.app_packageId,
                checkbox: "hide",
                names: {
                  label:
                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                      <Button shape="circular" id="ButtonHover" style={buttonContent} appearance="transparent" size="small"> {val.packageName !== null ? val.packageName : 'N/A'} </Button></Tooltip>
                  , icon: "", id: `${i}`
                },
                description: { label: <Caption1 > {val.packageDesc != "" ? val.packageDesc : 'N/A'} </Caption1>, status: "" },
                version: { label: <Caption1> {val.version} </Caption1> },
                os: { label: <Caption1> {val.platform} </Caption1> },
                created_on: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertUTCToReadableFormat(val.creationTime) : '-'} </Caption1>, },
                created_on_timezoned: { label: <Caption1> {(val.creationTime !== null && val.creationTime !== " ") ? convertToLocalTimezone(val.creationTime, userTimeZone) : '-'} </Caption1>, },
                modified_on: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertUTCToReadableFormat(val.lastModified) : "-"}</Caption1>, },
                modified_on_timezoned: { label: <Caption1>{(val.lastModified !== null && val.lastModified !== " ") ? convertToLocalTimezone(val.lastModified, userTimeZone) : "-"}</Caption1>, },
                // status: { label: <Caption1> {val.status} </Caption1>},
              });
          }
        } setTotalRecords(accumulator?.length)
        return accumulator;
      }, [])
      : [];
    // setExportData(tempExportData);
    console.log("tempTableData=", updatedTempTableData);
    setTableData(updatedTempTableData);
    // tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && final_data?.length > 0  && setLoading(false);
      if (isRefresh) {
        console.log("FIRST CALL");
        setIsRefresh(false);
        setRefreshToast(true);
        setTimeout(() => {
        setRefreshToast(false);
        }, 3000);
    }
    }, 500);
  }, [final_data, rowID, permissions]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
    contextValue.setSelectedRowIdInSubTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(true) : setDeleteDisabled(false);
  }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

  useEffect(() => {
    if (formDataPkg) {

      overlayName == 'addInstallation' && setInstallationOverLayData({
        headerTitle: "Create App Uninstall Profile",
        size: "large",
        isTabs: true,
        tabItems: {

          "Basic Details":<Stack tokens={{ padding: "5px 0px" }}>
            <StackItem>
              <Form ref={formRef}
                formData={formDataPkg}
                schema={jsonSchemaPkg}
                uiSchema={uiSchemaPkg}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataPkg(e.formData)} />
            </StackItem>
          </Stack>,

          "App Configuration": <Stack tokens={{ padding: "5px 0px" }}>
            {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
            <StackItem>
              <Form
              id="appinstallation"
                ref={formRef}
                formData={formDataApp}
                schema={jsonSchemaApp}
                uiSchema={uiSchemaApp}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataApp(e.formData)} />
            </StackItem>
          </Stack>,

          "Advance Configuration":
            <>
              <Stack tokens={{ padding: "5px 0px" }}>
                {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
                <Form
                  ref={formRef}
                  formData={formDataAdv}
                  schema={jsonSchemaAdv}
                  uiSchema={uiSchemaAdv}
                  validator={validator}
                  widgets={CustomWidgets}
                  onChange={(e) => setFormDataAdv(e.formData)} />
              </Stack>
            </>,

          "Review Data":
            <>
              <Stack>
                {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
                <Stack>
                  {/* <Text as = "h4" >Package Details</Text> */}
                  <Body1Strong>Package Details</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataPkg} schema={jsonSchemaPkg} uiSchema={uiSchemaPkg} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataPkg(e.formData)} />
                </Stack>
                <Stack>
                  {/* <Text>App Configurations</Text> */}
                  <Body1Strong>App Configurations</Body1Strong>
                  <Form id="appinstallation" disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
                </Stack>
                {/* <Text>Advance Configurations</Text> */}
                <Body1Strong>Advance Configurations</Body1Strong>
                <Stack horizontal tokens={{ childrenGap: 157, padding: "5px 0px" }}>
                  <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
                </Stack>    </Stack>
            </>
        }
      });


      // Object.keys(formDataPkg)?.length > 0 &&
      overlayName == 'editInstallation' && setInstallationOverLayData({
        headerTitle: "Edit Uninstallation Profile",
        size: "large",
        isTabs: true,
        tabItems: {

          "Basic Details":  spinnerLoad?
          <Stack horizontal verticalAlign="center" horizontalAlign="center" style={DynamicBoxingCSS}>
          <Spinner/>
          </Stack>
          :<Stack tokens={{ padding: "5px 0px" }}>
            {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
            <StackItem>
              <Form ref={formRef}
                formData={formDataPkg}
                schema={jsonSchemaPkg}
                uiSchema={uiSchemaPkg}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataPkg(e.formData)} />
            </StackItem>
          </Stack>,

          "App Configuration": <Stack tokens={{ padding: "5px 0px" }}>
            {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
            <StackItem>
              <Form
              id="appinstallation"
                ref={formRef}
                formData={formDataApp}
                schema={jsonSchemaApp}
                uiSchema={uiSchemaApp}
                validator={validator}
                widgets={CustomWidgets}
                onChange={(e) => setFormDataApp(e.formData)} />
            </StackItem>
          </Stack>,


          "Advance Configuration":
            <>
              <Stack tokens={{ padding: "5px 0px" }}>
                {/* <InfoBar title={"Sorem ipsum dolor sit amet, consectetur adipiscing elit. "}/> */}
                <Form
                  ref={formRef}
                  formData={formDataAdv}
                  schema={jsonSchemaAdv}
                  uiSchema={uiSchemaAdv}
                  validator={validator}
                  widgets={CustomWidgets}
                  onChange={(e) => setFormDataAdv(e.formData)} />
              </Stack>
            </>,

          "Review Data":
            <>
              <Stack>
                <Stack>
                  <Text as="h4" >Package Details</Text>
                  <Form id="appinstallation" disabled={true} formData={formDataPkg} schema={jsonSchemaPkg} uiSchema={uiSchemaPkg} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataPkg(e.formData)} />
                </Stack>
                <Stack>
                  <Text>App Configurations</Text>
                  <Form id="appinstallation" disabled={true} formData={formDataApp} schema={jsonSchemaApp} uiSchema={uiSchemaApp} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataApp(e.formData)} />
                </Stack>
                <Text>Advance Configurations</Text>
                <Stack horizontal tokens={{ childrenGap: 157, padding: "5px 0px" }}>
                  <Form disabled={true} formData={formDataAdv} schema={jsonSchemaAdv} uiSchema={uiSchemaAdv} validator={validator} widgets={CustomWidgets} onChange={(e) => setFormDataAdv(e.formData)} />
                </Stack>    </Stack>
            </>
        },
      });
    }
  }, [overlayName, formDataPkg, formDataApp, formDataAdv]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  <Breadcrumbs
                    items={[
											{name: "Automate", link: "/home" },
                      {name:"Apps", link:"/automate/apps/appmonitored"},
                      {name:"App Uninstall Profile", link:"#"}
                    ]} 
                  /> 
                  </StackItem>
              </Stack>
            </StackItem>
            <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AutomateAppPages(`App${" "}Uninstall${" "}Profiles`)} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem>
                        <StackItem style={wraperStyle}>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                             <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                             </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                      {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {(dropDownValue1 === "Name" || dropDownValue1 === "Description" || dropDownValue1 === "Version") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {dropDownValue1 === "Status" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? (<span style={{ color: 'red' }}>This column is already filtered</span>) : (<DropdownComponent optionData={statusOptions} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />))}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>

                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 &&
                                // <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                  {/* </Stack> */}
                                </Stack>}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>

                      </StackItem >
                      <Swd_func filterArray={filterArray} data={final_data}
                        func={set_final_data}
                        searchVal={searchVal}
                        pageNo={(currentPageNo - 1) * 10}
                        setTotalPages={setTotalPages}
                        setTotalRecords={setTotalRecords}
                        isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2}
                        savePackageDetails={savePackageDetails}
                        setSavePackageDetails={setSavePackageDetails}
                        setDeleteDisabled={setDeleteDisabled}
                        deleteprofile={deleteprofile}
                        setDeleteprofile={setDeleteprofile}
                        pkgId={deleteId}
                        setJsonDataPkg={setJsonDataPkg}
                        setUiDataPkg={setUiDataPkg}
                        setJsonDataApp={setJsonDataApp}
                        setUiDataApp={setUiDataApp}
                        setJsonDataAdv={setJsonDataAdv}
                        setUiDataAdv={setUiDataAdv}
                        formDataPkg={formDataPkg}
                        formDataApp={formDataApp}
                        formDataAdv={formDataAdv}
                        setFormDataPkg={setFormDataPkg}
                        setFormDataApp={setFormDataApp}
                        setFormDataAdv={setFormDataAdv}
                        rowID={rowID}
                        setRowconfID={setRowconfID}
                        rowconfID={rowconfID}
                        overlayName={overlayName}
                        handleEditData={handleEditData}
                        overlayOpen={overlayOpen}
                        setOverlayOpen={setOverlayOpen}
                        setRowId={setRowID}
                        status={status}
                        setStatus={setStatus}
                        setExportDetails={setExportDetails}
                        type={type}
                        isRefresh={isRefresh}
                        setIsRefresh={setIsRefresh}
                        setRefreshToast={setRefreshToast}
                        exportBtnClicked={exportBtnClicked}
                        setExportBtnClicked={setExportBtnClicked}
                        setSpinnerLoad={setSpinnerLoad}
                      />
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={installationOverLayData}
              saveBtnFunc={saveBtnFunc}
              isNavBtn={true}
              formRef={formRef}
            />
            {/* {savePackageDetails && <ToastComponent  setMess  toastIntent="success" position="top-end" title="Success" message="Package  Details have been saved Successfully" footer="" /> }   */}
            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"Package Saved Successfully"} footer="" />}
            {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
            {deleteprofile && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Deleted Successfully'} footer="" />}
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};

// function useFullScreenHandle() {
//   throw new Error("Function not implemented.");
// }